import type { FC } from 'react';
import { WarningIcon } from '@THC/components/Icons';
import { MDText } from 'i18n-react';

import type { ChatItem } from 'Features/AiCompanion/services';

import LocalTexts from '../../AiCompanion.texts';

import styles from './TimeoutItem.module.scss';

const LocalT = new MDText(LocalTexts);

interface TimeoutItemProps {
	item: ChatItem;
}

export const TimeoutItem: FC<TimeoutItemProps> = () => {
	return (
		<div className={styles.content}>
			<WarningIcon data-timeout-icon />
			<div>{LocalT.translate('chatItem.timeout')}</div>
		</div>
	);
};
